/* Mafess: seleccionar colores en las tarjetas desde un celular. */
(function () {
  function chooseVariant(link, card, event) {
    var variantId = link.getAttribute('data-swatch-variant');
    if (!variantId) return;

    var media = card.querySelector('deferred-loading[data-product-media-featured]');
    if (media && !media.hasAttribute('data-loaded') && typeof media.loadTemplate === 'function') {
      media.loadTemplate();
    }

    event.preventDefault();
    event.stopPropagation();
    var image = card.querySelector('[data-grid-image][data-variant-id="' + variantId + '"]');
    if (!image) {
      window.location.assign(link.href);
      return;
    }

    card.querySelectorAll('[data-grid-image].product-media__img--featured-visible, [data-variant-secondary-id].product-media__img--featured-visible').forEach(function (element) {
      element.classList.remove('product-media__img--featured-visible');
    });
    image.classList.add('product-media__img--featured-visible');
    card.classList.add('mf-card-color-selected');

    card.querySelectorAll('product-grid-item-swatch .swatch__link').forEach(function (element) {
      element.removeAttribute('aria-current');
    });
    link.setAttribute('aria-current', 'true');

    card.querySelectorAll('[data-grid-link]').forEach(function (productLink) {
      var url = new URL(productLink.href, window.location.href);
      url.searchParams.set('variant', variantId);
      productLink.href = url.toString();
    });
    var quickBuy = card.querySelector('[data-button-quick-view]');
    if (quickBuy && window.theme && window.theme.settings.quickBuy === 'quick_buy') {
      quickBuy.setAttribute('data-variant-id', variantId);
    }
  }

  function chooseSibling(link, card, event) {
    var imageUrl = link.getAttribute('data-sibling-featured-image-url');
    var image = card.querySelector('[data-main-image] img');
    if (!imageUrl || !image) return;

    event.preventDefault();
    event.stopPropagation();
    image.setAttribute('srcset', imageUrl);
    image.setAttribute('src', imageUrl);
    card.classList.add('mf-card-color-selected');

    card.querySelectorAll('sibling-swatches [data-sibling-swatch]').forEach(function (element) {
      element.removeAttribute('aria-current');
    });
    link.setAttribute('aria-current', 'true');
    card.querySelectorAll('[data-grid-link]').forEach(function (productLink) {
      productLink.href = link.href;
    });
  }

  document.addEventListener('click', function (event) {
    if (!window.matchMedia('(max-width: 767px)').matches || !event.target.closest) return;
    var link = event.target.closest('product-grid-item-swatch .swatch__link, sibling-swatches [data-sibling-swatch]');
    var card = link && link.closest('[data-product-block]');
    if (!card) return;
    if (link.hasAttribute('data-sibling-swatch')) {
      chooseSibling(link, card, event);
    } else {
      chooseVariant(link, card, event);
    }
  }, true);

  document.addEventListener('mouseleave', function (event) {
    if (window.matchMedia('(max-width: 767px)').matches &&
        event.target.matches('sibling-swatches') &&
        event.target.closest('.mf-card-color-selected')) {
      event.stopPropagation();
    }
  }, true);
})();
